<template>
  <div class="chart-wrap" v-if="Grafik">
    <div id="chart">
      <apexchart type=donut :height=Height :width=Width :options="chartOptions" :series="series"/>
    </div>
  </div>
</template>

<script>
export default {
  props: ["Grafik"],
  data() {
    return {
      series: null,
      chartOptions: null,
      Height: (window.innerHeight / 2) - 95,
      Width: (window.innerWidth / 2) - 200,
    }
  },
  methods: {
    GrafikCalistir() {
      this.series = this.Grafik.Bakiyeler;
      this.chartOptions = {
        theme: {
          mode: 'light',
          palette: 'palette3'
        },
        labels: this.Grafik.Kasalar,
        legend: {
          show: false,
          position: 'bottom',
        },
        responsive: [{
          breakpoint: 480,
          options: {
            chart: {
              width: 200
            },

          }
        }]
      }
    }
  },
  created() {
    this.GrafikCalistir();
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Pack/Yonetim/bina/Ekran/Detay/KasaGrafik.vue